import BALogo from "./component";

export default BALogo;